import Vue from 'vue'
import { FormatSalary, NumberToChinese, DateFormat, DateTimeFormat } from '@assets/site'

// https://cn.vuejs.org/v2/guide/custom-directive.html
Vue.directive('focus', {
  inserted: function (el) {
    const vel = el.__vue__;
    setTimeout(() => {
      vel.focus()
    }, 100);
  }
})

// 在切换标签时， el-table高度保持不了，修复了此问题
Vue.directive('el-table-height-fix', {
  inserted: function(el){
    setTimeout(() => {
      const div = el.closest('.el-table');
      const divHeight = div.offsetHeight;
      div.style.height = divHeight + 'px';
      div.style.maxHeight = divHeight + 'px';
    }, 10);
  }
})

Vue.directive('table-height-fix', {
  inserted: function(el){
    setTimeout(() => {
      const div = el;
      const divHeight = div.offsetHeight;
      div.style.height = divHeight + 'px';
      div.style.maxHeight = divHeight + 'px';
    }, 10);
  }
})

Vue.directive('div-height-fix', {
  inserted: function(el){
    setTimeout(() => {
      const div = el;
      const divHeight = div.offsetHeight;
      div.style.height = divHeight + 'px';
      div.style.maxHeight = divHeight + 'px';
      div.style.overflow = "auto";
    }, 10);
  }
})

Vue.filter('formatSalary', FormatSalary)

Vue.filter('numberToChinese', NumberToChinese)

Vue.filter('dateFormat', DateFormat)

Vue.filter('dateTimeFormat', DateTimeFormat)
